import styled from "styled-components";
import { FunctionComponent } from "react";

type SizeValue = number | string;

interface VodafoneLogoProps {
  size?: SizeValue;
  sizeSm?: SizeValue;
}

interface VodafoneLogoWrapperProps {
  $size: SizeValue;
  $sizeSm?: SizeValue;
}

const toCssSize = (v: SizeValue) => (typeof v === "number" ? `${v}px` : v);

export const VodafoneLogoWrapper = styled.svg<VodafoneLogoWrapperProps>`
  height: ${({ $size }) => toCssSize($size)};
  width: ${({ $size }) => toCssSize($size)};

  path {
    fill: white;
  }

  circle {
    fill: red;
  }

  ${({ theme, $sizeSm }) => $sizeSm && theme.customTheme.breakpoints.down("sm")} {
    height: ${({ $sizeSm }) => $sizeSm && toCssSize($sizeSm)};
    width: ${({ $sizeSm }) => $sizeSm && toCssSize($sizeSm)};
  }
`;

const VodafoneLogo: FunctionComponent<VodafoneLogoProps> = ({ size = 50, sizeSm = 39 }) => (
  <VodafoneLogoWrapper
    viewBox="0 0 311.8 311.8"
    id="icon-vodafone-logo"
    $size={size}
    $sizeSm={sizeSm}
    tabIndex={0}
    role="img"
    aria-label="Vodafone"
  >
    <g>
      <circle cx="155.9" cy="155.9" r="141.7" />
      <path d="M157 234.9c-38.9.1-79.5-33.1-79.6-86.5-.1-35.3 18.9-69.3 43.3-89.4 23.7-19.7 56.3-32.3 85.8-32.4 3.8 0 7.8.3 10.2 1.1-25.8 5.3-46.3 29.4-46.2 56.6 0 .9.1 1.9.2 2.3 43.2 10.5 62.7 36.6 62.9 72.6 0 36.1-28.5 75.6-76.6 75.7z" />
    </g>
  </VodafoneLogoWrapper>
);

export default VodafoneLogo;
